import logo from "@/assets/empro-logo.png";

export const Logo = ({ size = "md" }) => {
  const big = size === "lg";
  return (
    <img data-testid="empro-logo" src={logo} alt="EMPRO WORKWEAR – Professional Clothing"
      draggable={false} className={`${big ? "h-24 lg:h-28" : "h-9"} w-auto select-none`} />
  );
};
